import type { Starter } from '../Starter'

export const peopleStarters: Starter[] = [
  {
    id: 'org',
    name: 'Org Chart',
    description: 'People & teams',
    thumbnailUrl: '/assets/images/thumbnails/tb_org_chart.svg',
    translationKey: 'templates.names.orgChartClassic',
    // Opens the OrgChartStartPicker (Blank / sample / CSV / generate) —
    // same policy as the flowchart card. Deep links can still pass
    // seed=sample:org-25-sample.
    artifact: { kind: 'seed', seedId: 'org-25-sample', diagramType: 'org' },
    pickerOnOpen: true,
    job: ['chart-org'],
    function: ['people'],
    popular: true,
    growsInto: 'atlas',
    collaborative: ['assign-owners'],
    curatedBy: 'creately',
  },
  {
    id: 'reorg-plan',
    name: 'Reorg Plan',
    description: 'Restructure scenario',
    thumbnailUrl: '/assets/images/thumbnails/tb_org_chart.svg',
    artifact: { kind: 'seed', seedId: 'reorg-plan', diagramType: 'org' },
    job: ['chart-org'],
    function: ['people'],
    growsInto: 'atlas',
    trigger: 'reorg',
    collaborative: ['assign-owners'],
    curatedBy: 'creately',
  },
  {
    id: 'team-org-chart',
    name: 'Team Org Chart',
    description: 'Squads & reporting',
    thumbnailUrl: 'https://svg.template.creately.com/wdQqxCc1JVy',
    artifact: { kind: 'legacy', templateId: 'wdQqxCc1JVy', legacyType: 'diagram/def/block.js#Block' },
    job: ['chart-org'],
    function: ['people'],
    growsInto: 'atlas',
    collaborative: ['assign-owners'],
    curatedBy: 'creately',
  },
  {
    id: 'department-org-chart',
    name: 'Department Chart',
    description: 'Org by department',
    thumbnailUrl: 'https://svg.template.creately.com/hrhc6tp62',
    artifact: { kind: 'legacy', templateId: 'hrhc6tp62', legacyType: 'diagram/def/block.js#Block' },
    job: ['chart-org'],
    function: ['people'],
    growsInto: 'atlas',
    collaborative: ['assign-owners'],
    curatedBy: 'creately',
  },
  {
    id: 'raci-matrix',
    name: 'RACI Matrix',
    description: 'Roles & responsibilities',
    thumbnailUrl: 'https://svg.template.creately.com/bJ8ke7W9Fho',
    artifact: { kind: 'legacy', templateId: 'bJ8ke7W9Fho', legacyType: 'diagram/def/block.js#Block' },
    job: ['chart-org'],
    function: ['people'],
    collaborative: ['assign-owners'],
    curatedBy: 'creately',
  },
]
